import { Box, FormHelperText, TextField } from '@mui/material';
import { NumberFormatCustom } from 'components/common/simpleInputFields/numberField/helpers';
import { FormattedMessage, formatTranslation, unsafeTranslationKey } from 'intl';
import { CommonTranslationKeys } from 'intl/keys';
import { useIntl } from 'react-intl';
import type { ReactElement } from 'react';
import {
  segmentHelperTextSx,
  segmentHyphenSx,
  segmentIconSx,
  segmentRootSx,
  segmentTextFieldSx,
} from './styles';
import type { SingleSegmentProps } from './types';

function SegmentIcon({ color }: Readonly<{ color: string }>): ReactElement {
  return (
    <Box component="svg" sx={segmentIconSx} viewBox="3 3 18 18" fill="none">
      <path
        d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
        fill={color}
      />
      <rect x="7" y="7" width="10" height="10" rx="2" fill={color} />
    </Box>
  );
}

export function SingleSegment({
  index,
  rangeMin,
  rangeMax,
  color,
  onChange,
  error,
  disabled,
}: SingleSegmentProps): ReactElement {
  const intl = useIntl();

  return (
    <Box sx={segmentRootSx}>
      <Box className="inputsRow">
        <SegmentIcon color={color} />
        <TextField
          label={formatTranslation(intl, CommonTranslationKeys.from)}
          variant="outlined"
          value={rangeMin || ''}
          sx={segmentTextFieldSx}
          disabled={disabled}
          onChange={({ target: { value } }): void => {
            onChange(
              index,
              typeof value === 'number' && !Number.isNaN(value) ? value : undefined,
              'rangeMin'
            );
          }}
          InputProps={{
            inputComponent: NumberFormatCustom,
            inputProps: {
              decimalScale: 0,
            },
          }}
        />
        <Box component="span" sx={segmentHyphenSx} />
        <TextField
          label={formatTranslation(intl, CommonTranslationKeys.to)}
          variant="outlined"
          value={rangeMax || ''}
          sx={segmentTextFieldSx}
          disabled={disabled}
          onChange={({ target: { value } }): void => {
            onChange(
              index,
              typeof value === 'number' && !Number.isNaN(value) ? value : undefined,
              'rangeMax'
            );
          }}
          InputProps={{
            inputComponent: NumberFormatCustom,
            inputProps: {
              decimalScale: 0,
            },
          }}
        />
      </Box>
      <FormHelperText error={!!error} sx={segmentHelperTextSx}>
        {error ? (
          <FormattedMessage id={unsafeTranslationKey(error.helperText.id)} />
        ) : null}
      </FormHelperText>
    </Box>
  );
}
